<template>
  <div>
    <project-table
      ref="projectTable"
      :extraQuery="extraQuery"
      :operateColumns="operateColumns"
      :extraSearch="extraSearch"
    ></project-table>
    <!-- 审核文件列表 -->
    <Modal
      v-model="auditFileVisible"
      title="审核文件"
      width="800"
    >
      <div class="fileList">
        <Spin
          fix
          v-if="loadingFile"
        >文件加载中..</Spin>
        <Collapse accordion>
          <Panel
            v-for="fileType in allFiles"
            :key="fileType.fileTypeId"
          >
            <div style="display:inline-block;width:90%">
              <Button
                style="margin:0 10px"
                type="success"
                size="small"
              >{{fileType.dbfile.length}}</Button>
              <span>{{fileType.fileTypeName}}</span>
            </div>
            <div slot="content">
              <Table
                :columns="fileColumns"
                :data="fileType.dbfile"
              ></Table>
            </div>
          </Panel>
        </Collapse>
      </div>
      <div slot="footer">

      </div>
    </Modal>
    <!-- 审核 -->
    <Modal
      title="结项审核"
      v-model="examineVisible"
    >
      <div>
        <span>若审核不通过，请输入不通过原因</span>
        <Input
          style="margin:5px 0;"
          v-model="rejectReason"
        ></Input>
      </div>
      <div slot="footer">
        <Button
          type="success"
          @click="passProject"
        >通过</Button>
        <Button
          type="error"
          @click="rejectProject"
        >不通过</Button>
        <Button @click="examineVisible=false">取消</Button>
      </div>
    </Modal>
    <Modal
      title="结项详情"
      v-model="detailVisible"
    >
      <div class="examine-wrapper">
        <template v-if="examineDetails.length > 0">
          <div
            class="examine-item"
            v-for="examine in examineList"
          >
            <span style="margin-right:10px;"><span style="font-weight:bold">申请时间：</span>{{examine.applyTime}}</span>
            <span style="margin-right:10px;"><span style="font-weight:bold;">操作时间：</span>{{examine.rejectTime}}</span>
            <div>
              <span style="margin-right:10px;"><span style="font-weight:bold">操作人：</span>{{examine.rejectPerson}}</span>
              <span style="margin-right:10px;" v-if="examine.status"><span style="font-weight:bold">状态：</span>{{examine.status}}</span>
            </div>
            <div style="margin:5px 0 15px 0;">
              <span style="font-weight:bold">备注：</span>{{examine.rejectReason}}
            </div>
          </div>
        </template>
        <template v-else>
          <div class="examine-item">
            <span style="margin-right:10px;"><span style="font-weight:bold">申请时间：</span>{{projectData.appStartTime | filterTime}}</span>
            <span style="margin-right:10px;" v-if="projectData.appPassTime"><span style="font-weight:bold">操作时间：</span>{{projectData.appPassTime | filterTime}}</span>
            <span style="font-weight:bold">状态：</span>{{projectData.endStatusName}}
            <!-- <div style="margin:5px 0 15px 0;">
              <span style="font-weight:bold">状态：</span>{{projectData.endStatusName}}
            </div> -->
          </div>
        </template>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import ProjectTable from '@/components/projectTable'
import axios from 'axios'
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import x2js from "x2js"
import { formatDate } from '@/lib/tool'
import localFile from '@/lib/localFile'
import sendMessage from '@/lib/message'

export default {
  name: 'endProjectAudit',
  components: {
    ProjectTable
  },
  data() {
    return {
      projectData: {},
      operateColumns: [
        {
          title: '审核状态',
          width: 90,
          render: (h, params) => {
            if (!params.row.endStatusCode) {
              return h('div', '未发起')
            } else {
              if (parseInt(params.row.endStatusCode) === 3) {
                return h('div', `不通过`)
              } else if (parseInt(params.row.endStatusCode) === 2) {
                return h('div', '通过')
              } else {
                return h('div', '申请中')
              }
            }
          }
        },
        {
          title: '申请时间',
          width: 100,
          render: (h, params) => {
            let time = new Date(params.row.appStartTime).toLocaleDateString()
            return h('div', time)
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 220,
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'center'
              }
            }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.projectData = params.row
                      this.auditFileVisible = true
                      this.getFileAndTypes()
                      this.getReviewFile()
                    }
                  }
                }, '审核文件'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.projectData = params.row
                      this.rejectReason = ''
                      this.examineVisible = true
                    }
                  }
                }, '项目审核'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      this.projectData = params.row
                      const x2Json = new x2js()
                      this.examineDetails = []
                      if (this.projectData.endStatusName.indexOf('<recordList>') !== -1) {
                        this.examineDetails = x2Json.xml2js(this.projectData.endStatusName).recordList.record
                      }
                      this.detailVisible = true
                    }
                  }
                }, '详情'),
              ])
          }
        }
      ],
      fileColumns: [
        {
          title: '文件名称',
          key: 'fileName'
        },
        {
          title: '文件类别',
          key: 'fileTypeName',
          width: 100
        },
        {
          title: '操作',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.viewFile(params.row)
                  }
                }
              }, '预览')
            ])
          }
        },
      ],
      extraQuery: {
        status: ' and (projectState == "已开评标完" or projectState == "项目结项" or projectState == "项目失败")',
        endStatus: '  and endStatusCode > "0"',
        rolePermission: ''
      },
      auditFileVisible: false,
      typesAndFiles: [],
      loadingFile: false,
      fileUrl: '',
      examineVisible: false,
      rejectReason: '',
      fileList: '',
      extraSearch: {
        searchEndTime: true,
        searchManager: true
      },
      username: '',
      detailVisible: false,
      examineDetails: []
    }
  },
  async created() {
    const x2Json = new x2js()
  },
  async mounted() {
    if (!this.$store.state.session.user) {
      await this.$store.dispatch({
        type: 'session/init'
      })
    }
    this.username = this.$store.state.session.user.name
  },
  computed: {
    allFiles() {
      return this.fileList.concat(this.typesAndFiles)
    },
    examineList() {
      return this.examineDetails.slice(1)
    }
  },
  methods: {
    async getReviewFile() {
      const fl = 67
      // let rep = await axios.post(`http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpGetFileList?npid=${this.projectData.id}&fl=${fl}`)
      const params = {
        filter: `fileTypeId=="${fl}" and projectId=="${this.projectData.id}"`
      }
      let rep = await ajax.get(requestUrls.clfile.getList, { params })
      
      let result = []
      rep.data.result.forEach(item => {
        result.push({
          fileGuid: item['fileGuid'],
          fileName: item['fileName'],
          fileSuffix: item['fileSuffix'],
          fileTypeId: item['fileTypeId'],
          fileTypeName: item['fileTypeName'],
          id: item.id,
          projectId: item['projectId'],
          uploadPerson: item['uploadPerson'],
          uploadTime: item['uploadTime']
        })

      })
      this.fileList = [
        {
          fileTypeId: fl,
          dbfile: result,
          fileTypeName: '评审文件'
        }
      ]
    },
    async getFileAndTypes() {
      this.loadingFile = true
      let rep = await ajax.get(requestUrls.ClFileGather.GetFileGather, {
        params: {
          pid: this.projectData.id
        }
      })
      this.loadingFile = false
      if (rep.data.success) {
        this.typesAndFiles = rep.data.result.items
      }
    },
    async viewFile(file) {
      // 文件地址
      // let requestUrl = `http://oa.chinapsp.cn:8088/FileModule/Gdfile/downFile?id=${row.id}&name=${this.username}`
      // 文件类型
      let fileType = file.fileSuffix

      this.loadingFile = true

      // 获取blob对象地址
      // let rep = await axios.get(requestUrl, { responseType: 'blob' })
      // let blob = new Blob([rep.data])
      // let fileUrl = window.URL.createObjectURL(blob)

      const blobUrl = await localFile.downLoadBlob(file.fileGuid, file.fileName, file.fileSuffix)

      this.loadingFile = false

      // pdf预览
      let pdfTypes = ['.pdf']
      if (pdfTypes.indexOf(fileType) !== -1) {
        window.open('pdf/web/viewer.html?file=' + blobUrl)
        return
      }

      // 图片预览
      let imgTypes = ['.png', '.jpg', '.jpeg']
      if (imgTypes.indexOf(fileType) !== -1) {
        this.$showImage(blobUrl)
        return
      }

      // localFile.currentLoad(blobUrl, file.fileName)
      localFile.directLoadFile(file.fileGuid, file.fileName, file.fileSuffix)

    },
    passProject() {
      this.$Modal.confirm({
        title: '结项通过',
        content: `项目：${this.projectData.projectName} 审核通过`,
        onOk: async () => {
          this.$Spin.show()
          try {
            // let time = new Date().toLocaleDateString()

            let time = formatDate()

            let endStatusName = ''
            const x2Json = new x2js()

            let record = [{}]
            if (this.projectData.endStatusName && this.projectData.endStatusName.indexOf('<recordList>') !== -1) {
              record = x2Json.xml2js(this.projectData.endStatusName).recordList.record
            }

            record.push({
              applyTime: this.projectData.appStartTime.replace('T', ' ').split('.')[0],
              rejectTime: time,
              rejectReason: this.rejectReason,
              rejectPerson: this.$store.state.session.user.name,
              status: '结项通过'
            })

            endStatusName = x2Json.js2xml({ recordList: { record: record } })

            let rep = await ajax.put(requestUrls.ClProjectDb.UpdateEndStatus, {
              id: this.projectData.id,
              endStatusCode: '2',
              endStatusName: endStatusName,
              appStartTime: this.projectData.appStartTime,
              appPassTime: time,
              appNoPassTime: ''
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('审核成功')
              this.examineVisible = false
              // 刷新数据
              this.$refs.projectTable.refreshProject()

              // 修改项目状态
              ajax.put(requestUrls.ClProjectDb.UpdateStatus, {
                id: this.projectData.id,
                projectState: '项目结项'
              })

              // 发送微信通知
              this.sendAuditMessage(record, {
                auditState: `审核通过-${this.projectData.projectFull}`,
                description: '结项通过'
              })

            } else {
              this.$Message.error('操作失败')
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('操作失败')
          }
        }
      })
    },
    rejectProject() {
      if (!this.rejectReason) {
        this.$Message.error('请输入结项不通过原因')
        return
      }
      this.$Modal.confirm({
        title: '结项不通过',
        content: `项目：${this.projectData.projectName} 审核不通过`,
        onOk: async () => {
          this.$Spin.show()
          try {

            let time = formatDate()

            let endStatusName = ''
            const x2Json = new x2js()

            let record = [{}]
            if (this.projectData.endStatusName && this.projectData.endStatusName.indexOf('<recordList>') !== -1) {
              record = x2Json.xml2js(this.projectData.endStatusName).recordList.record
            }

            record.push({
              applyTime: this.projectData.appStartTime.replace('T', ' ').split('.')[0],
              rejectTime: time,
              rejectReason: this.rejectReason,
              rejectPerson: this.$store.state.session.user.name,
              status: '结项退回'
            })

            endStatusName = x2Json.js2xml({ recordList: { record: record } })

            let rep = await ajax.put(requestUrls.ClProjectDb.UpdateEndStatus, {
              id: this.projectData.id,
              endStatusCode: '3',
              endStatusName: endStatusName,
              appStartTime: this.projectData.appStartTime,
              appPassTime: '',
              appNoPassTime: time
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('审核成功')
              this.examineVisible = false
              // 刷新数据
              this.$refs.projectTable.refreshProject()
              // 修改项目状态
              if (this.projectData.projectState === '项目结项') {
                ajax.put(requestUrls.ClProjectDb.UpdateStatus, {
                  id: this.projectData.id,
                  projectState: '已开评标完'
                })
              }

              // 发送微信通知
              this.sendAuditMessage(record, {
                auditState: `审核不通过-${this.projectData.projectFull}`,
                description: this.rejectReason
              })

            } else {
              this.$Message.error('操作失败')
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('操作失败')
          }
        }
      })
    },
    // 获取申请人发送消息
    sendAuditMessage (record, params) {
      // 获取申请人
      let applyName = ''
      const reverseRecord = record.reverse()
      for (let i = 0; i < reverseRecord.length; i++) {
        const item = reverseRecord[i]
        if (item.status === '结项申请') {
          applyName = item.rejectPerson
          break
        }
      }
      const { auditState, description } = params
      const messageParams = {
        uniqueId: applyName,
        contentJson: {
          title: auditState,
          subTitle: '结项申请',
          url: 'http://qy.chinapsp.cn:8884?qyLogin#/projectCenter/documentSummary',
          description
        }
      }
      sendMessage('wechat', messageParams)
    }
  },
  filters: {
    filterTime(val) {
      if (!val) {
        return ''
      }
      return val.replace('T', ' ').split('.')[0]
    }
  }
}
</script>

<style lang="less" scoped>
.fileList {
  overflow: auto;
  max-height: 400px !important;
}
</style>
